import { useState } from "react";

let autoGeneratedId = 0;

export const useUniqueId = (): number => {
  const [asideId] = useState(() => ++autoGeneratedId);

  return asideId;
};
